import { Provider, WorkflowDiagram, WorkflowEnvVars } from '../types'
import { BQConnection } from '../workflow/connections/bigquery'
import { DBricksConnection } from '../workflow/connections/databricks'
import { OracleConnection } from '../workflow/connections/oracle'
import { PGConnection } from '../workflow/connections/postgres'
import { RSConnection } from '../workflow/connections/redshift'
import { SFConnection } from '../workflow/connections/snowflake'

import { ApiOutput } from './apioutput'
import { Area } from './area'
import { AsGeoJson } from './asgeojson'
import { AsWkt } from './aswkt'
import { BeginEndBlock } from './beginendblock'
import { BoundingBoxFromValues } from './bboxfromvalues'
import { Boundary } from './boundary'
import { BoundingBox } from './boundingbox'
import { GeoBuffer } from './buffer'
import { Call } from './call'
import { CaseWhen } from './casewhen'
import { Cast } from './cast'
import { Centroids } from './centroid'
import { ClipWithPolygons } from './clipwithpolygons'
import { ClipWithPolygonsDB } from './clipwithpolygons_db'
import { ClusterDBScan } from './clusterdbscan'
import { ClusterKMeans } from './clusterkmeans'
import { ColsToArray } from './colstoarray'
import { CommercialHotspots } from './commercialhotspots'
import { WorkflowComponent } from './common/workflowcomponent'
import { ConcaveHull } from './concavehull'
import { ConvexHull } from './convexhull'
import { CountRows } from './count'
import { CountPointsInPolygons } from './countpointsinpolygons'
import { CountPointsInPolygonsDB } from './countpointsinpolygons_db'
import { CreateBuilderMap } from './createbuildermap'
import { CreateGrid } from './creategrid'
import { CreateH3AggTileset } from './createh3aggtileset'
import { CreatePointAggTileset } from './createpointaggtileset'
import { CreateQuadbinAggTileset } from './createquadbinaggtileset'
import { CreateRoutes } from './createroutes'
import { CreateRoutingMatrix } from './createroutingmatrix'
import { CreateVectorTileset } from './createvectortileset'
import { CronbachAlphaCoefficient } from './cronbachalphacoefficient'
import { CrossJoin } from './crossjoin'
import { CustomPython } from './custompython'
import { CustomSQL } from './customsql'
import { Delaunay } from './delaunay'
import { DetectSpacetimeAnomalies } from './detectspacetimeanomalies'
import { DetectSpatialAnomalies } from './detectspatialanomalies'
import { Difference } from './difference'
import { DifferenceDB } from './difference_db'
import { DistanceToNearest } from './distance'
import { DistanceMatrix } from './distancematrix'
import { DistanceSingleTable } from './distancesingletable'
import { DistinctInColumn } from './distinct'
import { DrawCustomGeographies } from './drawcustomgeographies'
import { DropColumn } from './dropcolumn'
import { Dump } from './dump'
import { EnrichPoints } from './enrichpoints'
import { EnrichPointsDatabricks } from './enrichpoints_db'
import { EnrichPolygons } from './enrichpolygons'
import { EnrichPolygonsDatabricks } from './enrichpolygons_db'
import { WeightedEnrichPolygons } from './enrichpolygonsweighted'
import { EnrichPolygonsWeightedDatabricks } from './enrichpolygonsweighted_db'
import { ExportData } from './exportdata'
import { Extent } from './extent'
import { ExtractFromJSON } from './extractfromjson'
import { ExtractRaster } from './extractraster'
import { FindReplace } from './findreplace'
import { GeneratePoints } from './generatepoints'
import { GenerateUuid } from './generateuuid'
import { Geocode } from './geocode'
import { OracleGeocode } from './geocode_oracle'
import { GeogFromText } from './geogfromtext'
import { GeogPoint } from './geogpoint'
import { GeographytoGeometry } from './geographytogeometry'
import { GeometryToGeography } from './geometrytogeography'
import { GeometryType } from './geometrytype'
import { GeomFromGeoJson } from './geomfromgeojson'
import { GeomFromText } from './geomfromtext'
import { GetisOrd } from './getisord'
import { GetisOrdSpacetime } from './getisordspacetime'
import { GetTableByName } from './gettablebyname'
import { GroupBy } from './groupby'
import { GWR } from './gwr'
import { H3Boundary } from './h3boundary'
import { H3Center } from './h3center'
import { H3Distance } from './h3distance'
import { H3Enrich } from './h3enrich'
import { EnrichH3Databricks } from './h3enrich_db'
import { H3FromPoint } from './h3frompoint'
import { H3KRing } from './h3kring'
import { H3Polyfill } from './h3polyfill'
import { H3ToParent } from './h3toparent'
import { HexColorGenerator } from './hexcolorgenerator'
import { HTTPRequest } from './httprequest'
import { IfElse } from './ifelse'
import { ImportURL } from './importurl'
import { ImportURLFromTable } from './importurlfromtable'
import { Intersection } from './intersection'
import { IntersectRaster } from './intersectraster'
import { IsNotNull } from './isnotnull'
import { Isolines } from './isolines'
import { Join } from './join'
import { JoinExtended } from './joinextended'
import { JoinV2 } from './joinv2'
import { KNN } from './knn'
import { Length } from './length'
import { Limit } from './limit'
import { LineInterpolatePoint } from './lineinterpolatepoint'
import { LocalMoransI } from './localmoransi'
import { MakeLine } from './makeline'
import { MakePolygon } from './makepolygon'
import { McpToolOutput } from './mcptooloutput'
import { MlGenerateText } from './mlgeneratetext'
import { MoransI } from './moransi'
import { MultiColFormula } from './multicolformula'
import { MultiRowFormula } from './multirowformula'
import { NormalizeColumn } from './normalize'
import { NumGeometries } from './numgeometries'
import { NumPoints } from './numpoints'
import { OrderBy } from './orderby'
import { OracleLoadRaster } from './oracleloadraster'
import { OracleRasterSummaryStats } from './oraclerastersummarystats'
import { ParseJSON } from './parsejson'
import { Perimeter } from './perimeter'
import { PointFromStaticLatLon } from './pointfromstaticlatlon'
import { PointN } from './pointn'
import { PointStatsInPolygons } from './pointstatsinpolygons'
import { PointStatsInPolygonsDB } from './pointstatsinpolygons_db'
import { PolyBuild } from './polybuild'
import { Polygonize } from './polygonize'
import { PolySplit } from './polysplit'
import { PrepareForVisualization } from './prepareforvisualization'
import { QuadbinBoundary } from './quadbinboundary'
import { QuadbinCenter } from './quadbincenter'
import { QuadbinEnrich } from './quadbinenrich'
import { EnrichQuadbinDatabricks } from './quadbinenrich_db'
import { QuadbinFromPoint } from './quadbinfrompoint'
import { QuadbinKRing } from './quadbinkring'
import { QuadbinPolyfill } from './quadbinpolyfill'
import { QuadbinToParent } from './quadbintoparent'
import { ReadQuery } from './readquery'
import { ReadTable } from './readtable'
import { RefactorColumns } from './refactorcolumns'
import { RemoveDuplicatedRows } from './removeduplicatedrows'
import { RemoveHoles } from './removeholes'
import { RenameColumn } from './renamecolumn'
import { RowNumber } from './rownumber'
import { Sample } from './sample'
import { SaveAsTable } from './saveastable'
import { SaveToBucketAndNotify } from './savetobucketandnotify'
import { Select } from './select'
import { SelectExpression } from './selectexpression'
import { SetSrid } from './setsrid'
import { Simplify } from './simplify'
import { SnapToGrid } from './snaptogrid'
import { SpacetimeHotspotsClassification } from './spacetimehotspotsclassification'
import { SpatialCompositeSupervised } from './spatialcompositesupervised'
import { SpatialCompositeSupervisedSF } from './spatialcompositesupervised_sf'
import { SpatialCompositeUnsupervised } from './spatialcompositeunsupervised'
import { SpatialFilter } from './spatialfilter'
import { SpatialFilterDB } from './spatialfilter_db'
import { SpatialInfo } from './spatialinfo'
import { SpatialJoin } from './spatialjoin'
import { SpatialJoinSF } from './spatialjoin_sf'
import { SpatialMatch } from './spatialmatch'
import { SpatialProcess } from './spatialprocess'
import { Distance } from './stdistance'
import { DWithin } from './stdwithin'
import { Subdivide } from './subdivide'
import { SuccessError } from './successerror'
import { Summarize } from './summarize'
import { TableFromGeojson } from './tablefromgeojson'
import { TextToColumns } from './texttocolumns'
import { TimeSeriesClustering } from './timeseriesclustering'
import { TradeAreas } from './tradeareas'
import { Transpose } from './transpose'
import { Union } from './unionall'
import { Unique } from './unique'
import { Unnest } from './unnest'
import { Voronoi } from './voronoi'
import { TableFilter } from './where'
import { WhereSimplified } from './wheresimplified'
import { WKBFromGeoJson } from './wkbfromgeojson'
import { WKBFromText } from './wkbfromtext'
import { XYCoords } from './xycoords'

const minifiedNodeTypes = ['generic']

export class Toolbox {
  components: Record<string, WorkflowComponent>
  provider: Provider

  constructor(components: Record<string, WorkflowComponent>, provider: Provider) {
    this.components = components
    this.provider = provider
  }

  getWorkflowConfig(workflowDiagram: WorkflowDiagram): WorkflowDiagram {
    for (const node of workflowDiagram.nodes) {
      if (node.type && minifiedNodeTypes.includes(node.type)) {
        const componentName = node.data.name
        if (componentName in this.components) {
          const component = this.components[componentName]
          node.data.label = component.metadata.title
          node.data.inputs = node.data.inputs.map((nodeInput) => ({
            ...component.inputs.find((componentInput) => componentInput.name === nodeInput.name),
            ...nodeInput
          }))
        }
      }
    }
    return workflowDiagram
  }

  updateOutdatedNode(workflowDiagram: WorkflowDiagram, nodeId: string): WorkflowDiagram {
    for (const node of workflowDiagram.nodes) {
      if (node.id === nodeId && node.type && minifiedNodeTypes.includes(node.type)) {
        const componentName = node.data.name
        if (componentName in this.components) {
          const component = this.components[componentName]
          node.data.version = component.getVersion(workflowDiagram.connectionProvider)
          node.data.inputs = component.inputs.map((componentInput) => {
            const value = componentInput.value as string | boolean | number
            return {
              name: componentInput.name,
              ...(value ? { value } : {}),
              ...node.data.inputs.find((nodeInput) => nodeInput.name === componentInput.name)
            }
          })
          workflowDiagram.edges = workflowDiagram.edges.filter(
            (edge) =>
              !(
                edge.target === nodeId &&
                edge.targetHandle &&
                !component.inputs.map((componentInput) => componentInput.name).includes(edge.targetHandle)
              )
          )
        }
      }
    }
    return workflowDiagram
  }
}

export const allComponents = [
  new ApiOutput(),
  new Area(),
  new AsGeoJson(),
  new AsWkt(),
  new BeginEndBlock(),
  new Boundary(),
  new BoundingBox(),
  new BoundingBoxFromValues(),
  new Call(),
  new CaseWhen(),
  new Cast(),
  new Centroids(),
  new ClipWithPolygons(),
  new ClipWithPolygonsDB(),
  new ClusterDBScan(),
  new ClusterKMeans(),
  new ColsToArray(),
  new CommercialHotspots(),
  new ConcaveHull(),
  new ConvexHull(),
  new CountPointsInPolygons(),
  new CountPointsInPolygonsDB(),
  new CountRows(),
  new CreateBuilderMap(),
  new CreateGrid(),
  new CreateRoutes(),
  new CreateRoutingMatrix(),
  new CreateH3AggTileset(),
  new CreatePointAggTileset(),
  new CreateQuadbinAggTileset(),
  new CreateVectorTileset(),
  new CronbachAlphaCoefficient(),
  new CrossJoin(),
  new CustomPython(),
  new CustomSQL(),
  new Delaunay(),
  new DetectSpacetimeAnomalies(),
  new DetectSpatialAnomalies(),
  new Difference(),
  new DifferenceDB(),
  new Distance(),
  new DistanceMatrix(),
  new DistanceSingleTable(),
  new DistanceToNearest(),
  new DistinctInColumn(),
  new DrawCustomGeographies(),
  new DropColumn(),
  new Dump(),
  new DWithin(),
  new EnrichPoints(),
  new EnrichPointsDatabricks(),
  new EnrichPolygons(),
  new EnrichPolygonsDatabricks(),
  new EnrichPolygonsWeightedDatabricks(),
  new EnrichH3Databricks(),
  new EnrichQuadbinDatabricks(),
  new ExtractRaster(),
  new ExportData(),
  new Extent(),
  new ExtractFromJSON(),
  new FindReplace(),
  new GeneratePoints(),
  new GenerateUuid(),
  new GeoBuffer(),
  new Geocode(),
  new OracleGeocode(),
  new GeogFromText(),
  new GeogPoint(),
  new GeographytoGeometry(),
  new GeometryToGeography(),
  new GeometryType(),
  new GeomFromGeoJson(),
  new GeomFromText(),
  new GetisOrd(),
  new GetisOrdSpacetime(),
  new GetTableByName(),
  new GroupBy(),
  new GWR(),
  new H3Boundary(),
  new H3Center(),
  new H3Distance(),
  new H3Enrich(),
  new H3FromPoint(),
  new H3KRing(),
  new H3Polyfill(),
  new H3ToParent(),
  new HexColorGenerator(),
  new HTTPRequest(),
  new ImportURL(),
  new ImportURLFromTable(),
  new Intersection(),
  new IntersectRaster(),
  new IfElse(),
  new IsNotNull(),
  new Isolines(),
  new Join(),
  new JoinExtended(),
  new JoinV2(),
  new KNN(),
  new Length(),
  new Limit(),
  new LineInterpolatePoint(),
  new LocalMoransI(),
  new MakeLine(),
  new MakePolygon(),
  new McpToolOutput(),
  new MlGenerateText(),
  new MoransI(),
  new MultiColFormula(),
  new MultiRowFormula(),
  new NormalizeColumn(),
  new NumGeometries(),
  new NumPoints(),
  new PrepareForVisualization(),
  new OrderBy(),
  new OracleLoadRaster(),
  new OracleRasterSummaryStats(),
  new ParseJSON(),
  new Perimeter(),
  new PointFromStaticLatLon(),
  new PointN(),
  new PointStatsInPolygons(),
  new PointStatsInPolygonsDB(),
  new PolyBuild(),
  new PolySplit(),
  new Polygonize(),
  new QuadbinBoundary(),
  new QuadbinCenter(),
  new QuadbinEnrich(),
  new QuadbinFromPoint(),
  new QuadbinKRing(),
  new QuadbinPolyfill(),
  new QuadbinToParent(),
  new ReadQuery(),
  new ReadTable(),
  new RefactorColumns(),
  new RemoveDuplicatedRows(),
  new RemoveHoles(),
  new RenameColumn(),
  new RowNumber(),
  new Sample(),
  new SaveAsTable(),
  new SaveToBucketAndNotify(),
  new Select(),
  new SelectExpression(),
  new SetSrid(),
  new Simplify(),
  new SnapToGrid(),
  new SpacetimeHotspotsClassification(),
  new SpatialCompositeSupervised(),
  new SpatialCompositeSupervisedSF(),
  new SpatialCompositeUnsupervised(),
  new SpatialFilter(),
  new SpatialFilterDB(),
  new SpatialInfo(),
  new SpatialJoin(),
  new SpatialJoinSF(),
  new SpatialMatch(),
  new SpatialProcess(),
  new Subdivide(),
  new SuccessError(),
  new Summarize(),
  new TableFilter(),
  new TableFromGeojson(),
  new TextToColumns(),
  new TimeSeriesClustering(),
  new TradeAreas(),
  new Transpose(),
  new Union(),
  new Unique(),
  new Unnest(),
  new Voronoi(),
  new XYCoords(),
  new WeightedEnrichPolygons(),
  new WhereSimplified(),
  new WKBFromGeoJson(),
  new WKBFromText()
]

export function connectionForProvider(provider: Provider) {
  if (provider === Provider.BigQuery) {
    return new BQConnection('dummy', 'temp', 'workspace', 'extensions')
  } else if (provider === Provider.Snowflake) {
    return new SFConnection('dummy', 'temp', 'workspace', 'extensions')
  } else if (provider === Provider.Postgres) {
    return new PGConnection('dummy', 'temp', 'workspace', 'extensions')
  } else if (provider === Provider.Redshift) {
    return new RSConnection('dummy', 'temp', 'workspace', 'extensions')
  } else if (provider === Provider.DatabricksRest) {
    return new DBricksConnection('dummy', 'temp', 'workspace', 'extensions')
  } else if (provider === Provider.Oracle) {
    return new OracleConnection('dummy', 'temp')
  }
}

export function getToolbox(provider: Provider, envVars?: WorkflowEnvVars): Toolbox {
  const connection = connectionForProvider(provider)

  const components: Record<string, WorkflowComponent> = {}
  const supportedComponents: Array<WorkflowComponent> = []
  if (connection) {
    for (const component of allComponents) {
      try {
        if (component.supportsProvider(provider)) {
          supportedComponents.push(component as WorkflowComponent)
        }
      } catch (e) {
        supportedComponents.push(component as WorkflowComponent)
      }
    }
    for (const component of supportedComponents) {
      const adaptedComponent = WorkflowComponent.clone(component)
      connection.adaptComponent(adaptedComponent)
      if (envVars) {
        adaptedComponent.adaptComponent(provider, envVars)
        adaptedComponent.applyPerParameterATVersionFilter(provider, envVars)
      }
      components[component.metadata.name] = adaptedComponent
    }
  }
  const toolbox = new Toolbox(components, provider)

  return toolbox
}
